import instance from '../instance';
import getLiveElement from './get-live-element';

const getLiveElementByStaticElement = (staticElement) => {
  const { referenceMap } = instance.driver;
  const elementId = referenceMap.getReferenceIdByStaticNode(staticElement);

  return getLiveElement(elementId);
};

export default getLiveElementByStaticElement;
